import React, { useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";

import { CustomButton, CustomDialog, CustomSelect, FeaturedIcon, FormElement, FormikTextField, MultiSelect } from "../../../components";

import css from "./modals.module.css";
import { useMutation } from "../../../hooks/use-mutation";
import RebatesClient from "../../../RebatesClient";

const ModalRebate = ({
  open,
  onClose,
  activeRebate,
  account
}) => {
  const [rebateChanged, setRebateChanged] = useState(false);


  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "saveRebateAmt",
    networkMode: "always",
    mutationFn: async (changedData) => await RebatesClient.saveRebateLevel({rebate_amt: rebateLevels?.find(rb=> rb.id == changedData.rebateLevelId ).value}, account?.id),
    onError: (err)=> {console.log(err)},
    onSuccess: (resp) => {
      if(resp.response.status == 200){
        onClose()
      }
      else {
        alert(`${resp.body.status}`)
      }

    }
  });



  const rebateLevels = [
    { id: 1, name: "1%", value: .01 },
    { id: 2, name: "2%", value: .02 },
    { id: 3, name: "3%", value: .03 },
    { id: 4, name: "4%", value: .04 },
    { id: 5, name: "5%", value: .05 },
    { id: 6, name: "6%", value: .06 },
  ];

  const activeRebateLevel = rebateLevels?.find(rb=> rb.value == activeRebate?.rebate_amt)

  const validationSchema = Yup.object({
  });

  const formik = useFormik({
    initialValues: {
      rebateLevelId: activeRebateLevel?.id
    },

    validationSchema: validationSchema,

    onSubmit: submitRequest
  });

  function handleSelect(event) {
    setRebateChanged(activeRebateLevel?.id != event.target.value)
    formik.handleChange(event)
  }

  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon={'Plus'} />
      Change Rebate
    </div>
  );

  return (
    <CustomDialog open={open} onClose={onClose} width={640} title={title}>
      <FormikProvider value={formik}>
        <Form className={css.modalForm}>
          <CustomSelect
            label="Rebate Level*"
            labelShrink={false}
            name="rebateLevelId"
            options={rebateLevels}
            value={formik.values.rebateLevelId}
            onChange={handleSelect}
            halfWidth
          />
          

          <div className={css.actions}>
            <CustomButton
              label="Cancel"
              onClick={onClose}
              color="secondary"
            />

            <CustomButton
              label="Save"
              type="submit"
              color={"primary"}
              onSubmit={formik.handleSubmit}
              disabled={!rebateChanged}
            />
          </div>
        </Form>
      </FormikProvider>
    </CustomDialog>
  );
};

export default ModalRebate;
